// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// /**
//  * VisitCounter Component
//  *
//  * This component displays a fixed visitor icon in the top-right corner.
//  * Clicking the icon opens a modal that displays the total and unique website
//  * visit counts for the current subdomain. Counts are fetched from the backend
//  * and are persisted in an SQLite database.
//  */
// function VisitCounter() {
//   // State for total and unique visits, with initial placeholder values.
//   // These will be updated with actual data from the backend.
//   const [totalVisits, setTotalVisits] = useState(1092);
//   const [uniqueVisits, setUniqueVisits] = useState(689);
//   // State to control the visibility of the modal
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   // State to track loading status for the API call
//   const [isLoading, setIsLoading] = useState(false);
//   // State for any error messages from the API call
//   const [error, setError] = useState(null);

//   // Define the base URL for your backend API.
//   // IMPORTANT: This must match the protocol, domain, and port of your Node.js server.
//   // For production, this should be your deployed backend URL (e.g., 'https://your-backend.render.com').
//   // For local development, it's typically 'http://localhost:3001'.
//   // Ensure the '/api' prefix matches how you've mounted visitorCountRoutes in server.js.
//   const API_BASE_URL = 'https://backend-code-6vqy.onrender.com'; // This should be the base URL for your API, without specific route prefixes like /abstract-submission. The /api prefix will be added below.

//   useEffect(() => {
//     /**
//      * Async function to record a visit and then fetch the latest counts from the backend.
//      * This function sends a POST request to increment the counter and receives the
//      * updated counts in response. It also handles loading states and errors.
//      */
//     const recordAndFetchVisits = async () => {
//       setIsLoading(true); // Set loading state to true
//       setError(null);     // Clear any previous errors
//       try {
//         // Construct the full API endpoint URL
//         const endpoint = `${API_BASE_URL}/api/record-visit`; // Corrected endpoint

//         // Send a POST request to the backend.
//         // `withCredentials: true` is vital for sending/receiving cookies, which are used for unique visitor tracking.
//         const response = await axios.post(endpoint, {}, {
//           withCredentials: true
//         });

//         // If the response contains data, update the component's state.
//         if (response.data) {
//           setTotalVisits(response.data.totalVisits);
//           setUniqueVisits(response.data.uniqueVisits);
//         }
//       } catch (err) {
//         console.error('Error recording/fetching visit:', err);
//         setError('Failed to load visit data.'); // Set error message
//         // You might want to keep the initial values or set them to 'N/A' on error
//         setTotalVisits(1092); // Revert to initial or default on error
//         setUniqueVisits(689); // Revert to initial or default on error
//       } finally {
//         setIsLoading(false); // Always set loading state to false when done
//       }
//     };

//     // Call the function to record and fetch visits when the component mounts.
//     recordAndFetchVisits();

//     // No specific cleanup needed for this simple API call, as it's a one-time fetch on mount.
//     return () => {};
//   }, []); // The empty dependency array ensures this effect runs only once after the initial render.

//   /**
//    * Toggles the modal's visibility.
//    */
//   const toggleModal = () => {
//     setIsModalOpen(!isModalOpen);
//   };

//   return (
//     <>
//       {/* Fixed visitor icon button in the top-right corner */}
//       <button
//         onClick={toggleModal}
//         className="fixed top-4 right-4 z-50 p-3 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg transition-all duration-300 ease-in-out transform hover:scale-110 focus:outline-none focus:ring-4 focus:ring-blue-300 active:scale-95"
//         aria-label="Toggle Visitor Statistics"
//       >
//         {/* SVG for a simple eye icon - representing 'visitors' */}
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           viewBox="0 0 24 24"
//           fill="currentColor"
//           className="w-6 h-6"
//         >
//           <path d="M12 4.5C7 4.5 2.73 7.61 0 12c2.73 4.39 7 7.5 12 7.5s9.27-3.11 12-7.5c-2.73-4.39-7-7.5-12-7.5zm0 13c-3.14 0-5.7-2.56-5.7-5.7s2.56-5.7 5.7-5.7 5.7 2.56 5.7 5.7-2.56 5.7-5.7 5.7zm0-9.2c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5z" />
//         </svg>
//       </button>

//       {/* Modal Overlay and Content */}
//       {isModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm animate-fade-in">
//           <div className="bg-white p-8 rounded-xl shadow-2xl max-w-sm w-full transform scale-95 opacity-0 animate-scale-in">
//             <div className="flex justify-between items-center mb-6">
//               <h2 className="text-2xl font-bold text-gray-800">Website Statistics</h2>
//               <button
//                 onClick={toggleModal}
//                 className="text-gray-500 hover:text-gray-700 focus:outline-none transition-colors duration-200 text-3xl font-light leading-none"
//                 aria-label="Close Modal"
//               >
//                 &times;
//               </button>
//             </div>

//             {isLoading ? (
//               <p className="text-center text-blue-600 text-lg">Loading statistics...</p>
//             ) : error ? (
//               <p className="text-center text-red-600 text-lg">{error}</p>
//             ) : (
//               <div className="space-y-4">
//                 <p className="text-gray-700 text-xl flex justify-between items-center">
//                   <span className="font-semibold text-gray-900">Total Visits:</span>
//                   <span className="text-blue-600 font-bold text-2xl">{totalVisits}</span>
//                 </p>
//                 <p className="text-gray-700 text-xl flex justify-between items-center">
//                   <span className="font-semibold text-gray-900">Unique Visitors:</span>
//                   <span className="text-green-600 font-bold text-2xl">{uniqueVisits}</span>
//                 </p>
//                 <p className="text-sm text-gray-500 mt-4 text-center">
//                   Counts are specific to the current subdomain and persist across server restarts.
//                 </p>
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// export default VisitCounter;










// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';

// /**
//  * VisitCounter Component
//  *
//  * This component displays a fixed visitor icon in the top-right corner.
//  * Clicking the icon opens a small, chat-like message box (speech bubble)
//  * that displays the total and unique website visit counts for the current subdomain.
//  * The message box automatically disappears after a short duration.
//  * Counts are fetched from the backend and are persisted in an SQLite database.
//  * The message box uses a typewriter-style font for a distinctive look.
//  */
// function VisitCounter() {
//   // State for total and unique visits, with initial placeholder values.
//   // These will be updated with actual data from the backend.
//   const [totalVisits, setTotalVisits] = useState(1092);
//   const [uniqueVisits, setUniqueVisits] = useState(689);
//   // State to control the visibility of the message box
//   const [isMessageBoxVisible, setIsMessageBoxVisible] = useState(false);
//   // State to track loading status for the API call
//   const [isLoading, setIsLoading] = useState(false);
//   // State for any error messages from the API call
//   const [error, setError] = useState(null);

//   // Ref for the timeout to clear it if the component unmounts or before setting a new one
//   const timerRef = useRef(null);

//   // Define the base URL for your backend API.
//   // IMPORTANT: This must match the protocol, domain, and port of your Node.js server.
//   // For production, this should be your deployed backend URL (e.g., 'https://backend-code-6vqy.onrender.com').
//   // For local development, it's typically 'http://localhost:3001'.
//   const API_BASE_URL = 'http://localhost:3001'; // Corrected for localhost testing

//   const REGISTER_BUTTON_COLOR = '#2563EB';
//   useEffect(() => {
//     /**
//      * Async function to record a visit and then fetch the latest counts from the backend.
//      * This function sends a POST request to increment the counter and receives the
//      * updated counts in response. It also handles loading states and errors.
//      */
//     const recordAndFetchVisits = async () => {
//       setIsLoading(true); // Set loading state to true
//       setError(null);     // Clear any previous errors
//       try {
//         // Construct the full API endpoint URL
//         const endpoint = `${API_BASE_URL}/api/record-visit`;

//         // Send a POST request to the backend.
//         // `withCredentials: true` is vital for sending/receiving cookies, which are used for unique visitor tracking.
//         const response = await axios.post(endpoint, {}, {
//           withCredentials: true
//         });

//         // If the response contains data, update the component's state.
//         if (response.data) {
//           setTotalVisits(response.data.totalVisits);
//           setUniqueVisits(response.data.uniqueVisits);
//         }
//       } catch (err) {
//         console.error('Error recording/fetching visit:', err);
//         setError('Failed to load visit data.'); // Set error message
//         setTotalVisits(1092); // Revert to initial or default on error
//         setUniqueVisits(689); // Revert to initial or default on error
//       } finally {
//         setIsLoading(false); // Always set loading state to false when done
//       }
//     };

//     // Call the function to record and fetch visits when the component mounts.
//     recordAndFetchVisits();

//     // Cleanup function: Clear any pending timers if the component unmounts
//     return () => {
//       if (timerRef.current) {
//         clearTimeout(timerRef.current);
//       }
//     };
//   }, []); // The empty dependency array ensures this effect runs only once after the initial render.

//   /**
//    * Toggles the message box's visibility and sets a timer to hide it.
//    */
//   const toggleMessageBox = () => {
//     // Clear any existing timer to prevent multiple boxes or premature hiding
//     if (timerRef.current) {
//       clearTimeout(timerRef.current);
//     }

//     setIsMessageBoxVisible(true); // Show the message box

//     // Set a timer to hide the message box after 5 seconds
//     timerRef.current = setTimeout(() => {
//       setIsMessageBoxVisible(false);
//     }, 5000); // 5000 milliseconds = 5 seconds
//   };

// return (
//   <>
//     {/* Fixed visitor icon button in the top-right corner */}
//     <button
//       onClick={toggleMessageBox}
//       className="fixed left-4 z-50 p-3 bg-one hover:bg-accent text-white rounded-full shadow-lg transition-all duration-300 ease-in-out transform hover:scale-110 focus:outline-none focus:ring-4 focus:ring-blue-300 active:scale-95"
//       aria-label="Toggle Visitor Statistics"
//     >
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         viewBox="0 0 24 24"
//         fill="currentColor"
//         className="w-6 h-6"
//       >
//         <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.7.9 2.97 1.95 2.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
//       </svg>
//     </button>

//     {/* Message Box for Visitor Statistics */}
//     {isMessageBoxVisible && (
//       <div
//         // Explicitly setting width and height using Tailwind classes
//         // Adjusted 'right' to be closer to the icon for better visual connection initially
//         className="fixed top-4 right-[5rem] z-[9999] shadow-xl animate-fade-in-slide-down w-[280px] h-[160px]"
//         role="alert"
//         style={{
//           // Padding should be applied to the content div, not the outer container
//           // as the SVG covers the whole container.
//           // The outer div's background is transparent now.
//           // This div is just the bounding box for the SVG and content.
//           position: 'relative',
//         }}
//       >
//         {/* SVG for the unique thought bubble background and border */}
//         <svg
//           className="absolute inset-0 w-full h-full" // Ensure SVG fills its parent div
//           style={{ zIndex: -1 }} // Place behind the content
//           // ViewBox dimensions should match the intended aspect ratio of your bubble
//           // It's crucial that these dimensions are proportional to the 'w-[280px] h-[160px]' above
//           viewBox="0 0 280 160" // Matches the div's dimensions for 1:1 scaling
//           preserveAspectRatio="none" // Stretch to fit the div
//         >
//           {/* Main Bubble Shape - Smoother, more rounded, adjusted for new viewBox */}
//           {/* Coordinates adjusted to fill the new 280x160 viewBox, leaving space for the pointer */}
//           <path
//             fill="white" // This ensures the inside of the bubble is white
//             stroke={REGISTER_BUTTON_COLOR} // Border color from Register button
//             strokeWidth="2"
//             // Path adjusted for the 280x160 viewBox. Pointer will emanate from the right.
//             d="M 15 80 C 0 50, 40 10, 140 10 C 240 10, 270 50, 265 80 C 260 110, 240 150, 140 150 C 40 150, 0 110, 15 80 Z"
//           />

//           {/* Thought Bubble Pointer (Tail) - Points from the bubble's right-top towards the icon */}
//           <path
//             fill="white" // This makes the inside of the pointer white
//             stroke={REGISTER_BUTTON_COLOR}
//             strokeWidth="2"
//             // Pointer coordinates adjusted for the new viewBox (280x160)
//             // Points from ~x=265 on the bubble towards the button
//             d="M 265 65 L 280 45 L 265 35 Z" // Adjusted for new viewBox and to point towards the button
//           />
//         </svg>

//         {/* Actual content inside the message box */}
//         {/* Apply padding directly to the content div so it's pushed away from the SVG edges */}
//         <div className="relative z-0 p-4"> {/* Added p-4 here */}
//           <div className="flex justify-between items-start mb-2">
//             <h3 className="text-lg font-bold text-gray-800 font-mono">Site Stats</h3>
//             <button
//               onClick={() => setIsMessageBoxVisible(false)}
//               className="text-gray-400 hover:text-gray-600 focus:outline-none transition-colors duration-200 text-xl leading-none font-mono"
//               aria-label="Close"
//             >
//               &times;
//             </button>
//           </div>
//           {isLoading ? (
//             <p className="text-center text-blue-600 text-sm font-mono">Loading...</p>
//           ) : error ? (
//             <p className="text-center text-red-600 text-sm font-mono">{error}</p>
//           ) : (
//             <div className="text-sm font-mono">
//               <p className="text-gray-700 flex justify-between">
//                 <span className="font-semibold">Total:</span>
//                 <span className="text-blue-600 font-bold">{totalVisits}</span>
//               </p>
//               <p className="text-gray-700 flex justify-between">
//                 <span className="font-semibold">Unique:</span>
//                 <span className="text-green-600 font-bold">{uniqueVisits}</span>
//               </p>
//             </div>
//           )}
//           <p className="text-xs text-gray-500 mt-2 text-right font-mono">
//             Per subdomain
//           </p>
//         </div>
//       </div>
//     )}
//   </>
// );
// }

// export default VisitCounter;





// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { Users, User, X, BarChart2 } from 'lucide-react'; // Importing icons from lucide-react

// /**
//  * VisitCounter Component
//  *
//  * This component displays a visitor icon which, when clicked, opens a small,
//  * rectangular message box (popover) displaying the total and unique website
//  * visit counts for the current subdomain. The popover appears relative to the icon
//  * and automatically disappears after a short duration.
//  * Counts are fetched from the backend and are persisted in an SQLite database.
//  */
// function VisitCounter() {
//   const [totalVisits, setTotalVisits] = useState(1092);
//   const [uniqueVisits, setUniqueVisits] = useState(689);
//   const [isMessageBoxVisible, setIsMessageBoxVisible] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const timerRef = useRef(null);
//   const iconRef = useRef(null); // Ref to attach to the visitor icon button

//   // IMPORTANT: For production, change this to your deployed backend URL.
//   // For local development, it's typically 'http://localhost:3001'.
//   const API_BASE_URL = 'http://localhost:3001'; // Corrected for localhost testing

//   // Color from the Register button for consistency, if needed for borders or highlights
//   const REGISTER_BUTTON_COLOR = '#2563EB'; // This is a blue, typically `bg-blue-600` in Tailwind

//   useEffect(() => {
//     const recordAndFetchVisits = async () => {
//       setIsLoading(true);
//       setError(null);
//       try {
//         const endpoint = `${API_BASE_URL}/api/record-visit`;
//         const response = await axios.post(endpoint, {}, {
//           withCredentials: true
//         });

//         if (response.data) {
//           setTotalVisits(response.data.totalVisits);
//           setUniqueVisits(response.data.uniqueVisits);
//         }
//       } catch (err) {
//         console.error('Error recording/fetching visit:', err);
//         setError('Failed to load visit data.');
//         setTotalVisits(1092); // Revert to initial or default on error
//         setUniqueVisits(689); // Revert to initial or default on error
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     recordAndFetchVisits();

//     return () => {
//       if (timerRef.current) {
//         clearTimeout(timerRef.current);
//       }
//     };
//   }, []);

//   const toggleMessageBox = () => {
//     if (timerRef.current) {
//       clearTimeout(timerRef.current);
//     }
//     // Toggle visibility: if it's visible, hide it; if hidden, show it.
//     setIsMessageBoxVisible(prev => !prev);

//     // If showing, set a timer to hide it after 5 seconds
//     if (!isMessageBoxVisible) {
//       timerRef.current = setTimeout(() => {
//         setIsMessageBoxVisible(false);
//       }, 5000);
//     }
//   };

//   return (
//     <div className="relative inline-block"> {/* Wrapper for positioning the popover relative to the button */}
//       {/* Visitor icon button */}
//       <button
//   ref={iconRef}
//   onClick={toggleMessageBox}
//   className="p-3 bg-one mt-[-2] absolute hover:bg-accent text-white rounded-full shadow-lg transition-all duration-300 ease-in-out transform hover:scale-110 focus:outline-none focus:ring-4 focus:ring-blue-300 active:scale-95 cursor-pointer position z-[100]" // <--- Added cursor-pointer
//   aria-label="Toggle Visitor Statistics"
// >
//         <BarChart2 className="w-6 h-6" /> {/* Using BarChart2 for a statistics icon */}
//       </button>

//       {/* Message Box for Visitor Statistics */}
//       {isMessageBoxVisible && (
//         <div
//           // Positioned absolutely relative to the parent `.relative` div
//           // Adjusted `bottom` and `right` to place it above and slightly to the right of the button
//           className="absolute bottom-full right-0 mb-2
//                      w-[250px] p-4 rounded-lg shadow-xl
//                      bg-white bg-opacity-90 backdrop-filter backdrop-blur-sm
//                      border border-gray-200 text-gray-800 animate-fade-in-scale"
//           role="alert"
//           style={{ transformOrigin: 'bottom right' }} // For animation origin
//         >
//           <div className="flex justify-between items-center mb-2">
//             <h3 className="text-lg font-bold font-sans">Site Statistics</h3> {/* Changed font to sans for general use */}
//             <button
//               onClick={() => setIsMessageBoxVisible(false)}
//               className="text-gray-400 hover:text-gray-600 focus:outline-none transition-colors duration-200 text-xl leading-none"
//               aria-label="Close"
//             >
//               <X size={20} /> {/* Using Lucide-react X icon for close */}
//             </button>
//           </div>
//           {isLoading ? (
//             <p className="text-center text-blue-600 text-sm font-sans">Loading...</p>
//           ) : error ? (
//             <p className="text-center text-red-600 text-sm font-sans">{error}</p>
//           ) : (
//             <div className="text-sm font-sans space-y-2"> {/* Added space-y for vertical gap */}
//               <p className="text-gray-700 flex items-center justify-between">
//                 <span className="font-semibold flex items-center gap-2">
//                   <Users size={16} /> Total Visits:
//                 </span>
//                 <span className="text-blue-600 font-bold">{totalVisits}</span>
//               </p>
//               <p className="text-gray-700 flex items-center justify-between">
//                 <span className="font-semibold flex items-center gap-2">
//                   <User size={16} /> Unique Visitors:
//                 </span>
//                 <span className="text-green-600 font-bold">{uniqueVisits}</span>
//               </p>
//             </div>
//           )}
//           <p className="text-xs text-gray-500 mt-3 text-right font-sans">
//             Per subdomain
//           </p>
//         </div>
//       )}
//     </div>
//   );
// }

// export default VisitCounter;


// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { Users, User, X, BarChart2 } from 'lucide-react'; // Importing icons from lucide-react

// function VisitCounter() {
//   const [totalVisits, setTotalVisits] = useState(1092);
//   const [uniqueVisits, setUniqueVisits] = useState(689);
//   const [isMessageBoxVisible, setIsMessageBoxVisible] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const timerRef = useRef(null);
//   const componentRef = useRef(null); // Ref for the VisitCounter's main div

//   // IMPORTANT: For production, change this to your deployed backend URL.
//   const API_BASE_URL = 'https://backend-code-6vqy.onrender.com/api/visitorCountRoutes/api/record-visit';

//   const REGISTER_BUTTON_COLOR = '#2563EB';

//   useEffect(() => {
//     const recordAndFetchVisits = async () => {
//       setIsLoading(true);
//       setError(null);
//       try {
//         const endpoint = `${API_BASE_URL}/api/record-visit`;
//         const response = await axios.post(endpoint, {}, {
//           withCredentials: true
//         });

//         if (response.data) {
//           setTotalVisits(response.data.totalVisits);
//           setUniqueVisits(response.data.uniqueVisits);
//         }
//       } catch (err) {
//         console.error('Error recording/fetching visit:', err);
//         setError('Failed to load visit data.');
//         setTotalVisits(1092);
//         setUniqueVisits(689);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     recordAndFetchVisits();

//     return () => {
//       if (timerRef.current) {
//         clearTimeout(timerRef.current);
//       }
//     };
//   }, []);

//   const toggleMessageBox = () => {
//     if (timerRef.current) {
//       clearTimeout(timerRef.current);
//     }
//     setIsMessageBoxVisible(prev => !prev);

//     if (!isMessageBoxVisible) {
//       timerRef.current = setTimeout(() => {
//         setIsMessageBoxVisible(false);
//       }, 5000);
//     }
//   };

//   return (
//     // This div needs to be 'relative' to correctly position the absolute message box.
//     // It should *not* be fixed or absolute itself to remain in the normal document flow.
//     <div ref={componentRef} className="relative inline-block z-50"> {/* Add z-50 here if this component should be above other elements in the footer. */}
//       {/* Visitor icon button */}
//       <button
//         onClick={toggleMessageBox}
//         // Removed any fixed/absolute positioning from here.
//         // `cursor-pointer` and `relative z-[50]` were added previously, keeping them.
//         className="p-2 bg-one hover:bg-accent text-white rounded-full shadow-lg transition-all duration-300 ease-in-out transform hover:scale-110 focus:outline-none focus:ring-4 focus:ring-blue-300 active:scale-95 flex items-center justify-center cursor-pointer"
//         aria-label="Toggle Visitor Statistics"
//       >
//         <BarChart2 className="w-6 h-6" />
//       </button>

//       {/* Message Box for Visitor Statistics */}
//       {isMessageBoxVisible && (
//         <div
//           // Positioned absolutely relative to the parent `.relative` div of VisitCounter.
//           // Adjust `bottom` and `right` to place it above and slightly to the right of the button
//           className="absolute bottom-full right-0 mb-2
//                      w-[250px] p-4 rounded-lg shadow-xl
//                      bg-white bg-opacity-90 backdrop-filter backdrop-blur-sm
//                      border border-gray-200 text-gray-800 animate-fade-in-scale
//                      z-[60]" // Higher z-index than the button for the popover
//           role="alert"
//           style={{ transformOrigin: 'bottom right' }}
//         >
//           <div className="flex justify-between items-center mb-2">
//             <h3 className="text-lg font-bold font-sans">Site Statistics</h3>
//             <button
//               onClick={() => setIsMessageBoxVisible(false)}
//               className="text-gray-400 hover:text-gray-600 focus:outline-none transition-colors duration-200 text-xl leading-none"
//               aria-label="Close"
//             >
//               <X size={20} />
//             </button>
//           </div>
//           {isLoading ? (
//             <p className="text-center text-blue-600 text-sm font-sans">Loading...</p>
//           ) : error ? (
//             <p className="text-center text-red-600 text-sm font-sans">{error}</p>
//           ) : (
//             <div className="text-sm font-sans space-y-2">
//               <p className="text-gray-700 flex items-center justify-between">
//                 <span className="font-semibold flex items-center gap-2">
//                   <Users size={16} /> Total Visits:
//                 </span>
//                 <span className="text-blue-600 font-bold">{totalVisits}</span>
//               </p>
//               <p className="text-gray-700 flex items-center justify-between">
//                 <span className="font-semibold flex items-center gap-2">
//                   <User size={16} /> Unique Visitors:
//                 </span>
//                 <span className="text-green-600 font-bold">{uniqueVisits}</span>
//               </p>
//             </div>
//           )}
//           <p className="text-xs text-gray-500 mt-3 text-right font-sans">
//             Per subdomain
//           </p>
//         </div>
//       )}
//     </div>
//   );
// }

// export default VisitCounter;



import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Users, User, X, BarChart2 } from 'lucide-react'; // Importing icons from lucide-react

function VisitCounter() {
  const [totalVisits, setTotalVisits] = useState(1092);
  const [uniqueVisits, setUniqueVisits] = useState(689);
  const [isMessageBoxVisible, setIsMessageBoxVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const timerRef = useRef(null);
  const componentRef = useRef(null); // Ref for the VisitCounter's main div

  // Define endpoints based on your backend routes
  const API_RECORD_VISIT_ENDPOINT = 'https://backend-code-6vqy.onrender.com/api/record-visit';
  const API_GET_VISITS_ENDPOINT = 'https://backend-code-6vqy.onrender.com/api/get-visits';

  // REGISTER_BUTTON_COLOR is not used in the provided JSX, but kept for completeness.
  const REGISTER_BUTTON_COLOR = '#2563EB';

  useEffect(() => {
    const fetchAndRecordVisits = async () => {
      setIsLoading(true);
      setError(null);
      try {
        // Step 1: First, attempt to fetch current visit counts (GET request)
        // This ensures the component displays the latest counts quickly
        const getResponse = await axios.get(API_GET_VISITS_ENDPOINT, {
          withCredentials: true
        });

        if (getResponse.data) {
          setTotalVisits(getResponse.data.totalVisits);
          setUniqueVisits(getResponse.data.uniqueVisits);
        }

        // Step 2: Then, record the current visit (POST request)
        // This increments the counts on the backend and gets the updated values
        const postResponse = await axios.post(API_RECORD_VISIT_ENDPOINT, {}, {
          withCredentials: true // Crucial for sending cookies (e.g., for unique visitor tracking)
        });

        if (postResponse.data) {
          // Update state with the newly incremented values from the POST response
          setTotalVisits(postResponse.data.totalVisits);
          setUniqueVisits(postResponse.data.uniqueVisits);
        }

      } catch (err) {
        console.error('Error in visit counter operations:', err);
        let errorMessage = 'Failed to load visit data.';
        if (axios.isAxiosError(err)) {
          if (err.response) {
            errorMessage = `Error ${err.response.status}: ${err.response.data?.message || 'Server responded with an error.'}`;
            if (err.response.status === 404) {
              errorMessage = 'API endpoint not found. Please check URL and backend routes.';
            }
          } else if (err.request) {
            errorMessage = 'No response from server. Check network connection or backend server status.';
          } else {
            errorMessage = `Request setup error: ${err.message}`;
          }
        } else {
          errorMessage = `An unexpected error occurred: ${err.message}`;
        }
        setError(errorMessage);
        
        // Fallback values in case of error
        setTotalVisits(1092); 
        setUniqueVisits(689); 
      } finally {
        setIsLoading(false);
      }
    };

    fetchAndRecordVisits();

    return () => {
      // Clear any pending timers when the component unmounts
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []); // Empty dependency array ensures this effect runs only once after initial render

  const toggleMessageBox = () => {
    // Clear any existing timer to prevent immediate closing if already open
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    // Toggle the visibility state
    setIsMessageBoxVisible(prev => !prev);

    // If the message box is being opened, set a timer to hide it after 5 seconds
    if (!isMessageBoxVisible) { // Check the state *before* it's updated by setIsMessageBoxVisible
      timerRef.current = setTimeout(() => {
        setIsMessageBoxVisible(false);
      }, 5000); // Hide after 5 seconds
    }
  };

  return (
    // This div needs to be 'relative' to correctly position the absolute message box.
    // It should *not* be fixed or absolute itself to remain in the normal document flow.
    <div ref={componentRef} className="relative inline-block z-50"> {/* Add z-50 here if this component should be above other elements in the footer. */}
      {/* Visitor icon button */}
      <button
        onClick={toggleMessageBox}
        className="p-2 bg-one hover:bg-accent text-white rounded-full shadow-lg transition-all duration-300 ease-in-out transform hover:scale-110 focus:outline-none focus:ring-4 focus:ring-blue-300 active:scale-95 flex items-center justify-center cursor-pointer"
        aria-label="Toggle Visitor Statistics"
      >
        <BarChart2 className="w-6 h-6" />
      </button>

      {/* Message Box for Visitor Statistics */}
      {isMessageBoxVisible && (
        <div
          // Positioned absolutely relative to the parent `.relative` div of VisitCounter.
          // Adjust `bottom` and `right` to place it above and slightly to the right of the button
          className="absolute bottom-full right-0 mb-2
                     w-[250px] p-4 rounded-lg shadow-xl
                     bg-white bg-opacity-90 backdrop-filter backdrop-blur-sm
                     border border-gray-200 text-gray-800 animate-fade-in-scale
                     z-[60]" // Higher z-index than the button for the popover
          role="alert"
          style={{ transformOrigin: 'bottom right' }}
        >
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-lg font-bold font-sans">Site Statistics</h3>
            <button
              onClick={() => setIsMessageBoxVisible(false)}
              className="text-gray-400 hover:text-gray-600 focus:outline-none transition-colors duration-200 text-xl leading-none"
              aria-label="Close"
            >
              <X size={20} />
            </button>
          </div>
          {isLoading ? (
            <p className="text-center text-blue-600 text-sm font-sans">Loading...</p>
          ) : error ? (
            <p className="text-center text-red-600 text-sm font-sans">{error}</p>
          ) : (
            <div className="text-sm font-sans space-y-2">
              <p className="text-gray-700 flex items-center justify-between">
                <span className="font-semibold flex items-center gap-2">
                  <Users size={16} /> Total Visits:
                </span>
                <span className="text-blue-600 font-bold">{totalVisits}</span>
              </p>
              <p className="text-gray-700 flex items-center justify-between">
                <span className="font-semibold flex items-center gap-2">
                  <User size={16} /> Unique Visitors:
                </span>
                <span className="text-green-600 font-bold">{uniqueVisits}</span>
              </p>
            </div>
          )}
          <p className="text-xs text-gray-500 mt-3 text-right font-sans">
            Per subdomain
          </p>
        </div>
      )}
    </div>
  );
}

export default VisitCounter;
